import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";


// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const ListDiscussionVideoLessonsSlice = createSlice({
  name: "ListDiscussionVideoLessonsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    ListDiscussionVideoLesson: (state, action) => {
      // state.isLoading = true;
      state.isLoading = false;
    },

    successListDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListDiscussionVideoLessons: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  ListDiscussionVideoLesson,
  successListDiscussionVideoLessons,
  failureListDiscussionVideoLessons,
} = ListDiscussionVideoLessonsSlice.actions;

export default ListDiscussionVideoLessonsSlice.reducer;
